import {
  ApiDatabaseDtOsSubstationsDeviceHierarchyDto,
  ApiExternalDtoSubstationsDeviceHierarchyExternalDto,
} from '@redux/apiSlices/substationApi';

export const buildMeasurementDeviceDict = (
  nodes: ApiExternalDtoSubstationsDeviceHierarchyExternalDto[] | null | undefined,
  path: string[] = [],
  result: Record<number, Record<string, string>> = {}
): Record<number, Record<string, string>> => {
  if (!Array.isArray(nodes)) return result;

  for (const node of nodes) {
    const currentPath = [...path, node.label];

    const isLeafDevice =
      node.type === 2 && (!node.options || node.options.length === 0) && typeof node.entityId === 'number';

    if (isLeafDevice) {
      const levels: Record<string, string> = {};
      currentPath.forEach((label, idx) => {
        levels[`level${idx + 1}`] = label;
      });
      result[node.entityId] = levels;
    } else if (Array.isArray(node.options)) {
      buildMeasurementDeviceDict(node.options, currentPath, result);
    }
  }

  return result;
};

type DeviceSearchResult = {
  deviceLabel?: string;
  measurementPointLabel?: string;
  substationLabel?: string;
  deviceId?: number;
  entityId?: number;
  tsoId?: number;
} | null;

function getCurrentLabelsAndIds(
  node: ApiDatabaseDtOsSubstationsDeviceHierarchyDto,
  parentSubstationLabel?: string,
  parentMeasurementPointLabel?: string
) {
  return {
    substationLabel: node.type === 0 ? (node.label ?? undefined) : parentSubstationLabel,
    measurementPointLabel: node.type === 1 ? (node.label ?? undefined) : parentMeasurementPointLabel,
    tsoId: node.type === 2 ? (node.tsoId ?? undefined) : undefined,
    entityId: node.type === 2 ? (node.entityId ?? undefined) : undefined,
  };
}

export function findDeviceAndSubstation(
  nodes: ApiDatabaseDtOsSubstationsDeviceHierarchyDto[],
  deviceId: number,
  parentSubstationLabel?: string,
  parentMeasurementPointLabel?: string
): DeviceSearchResult {
  for (const node of nodes) {
    const {
      substationLabel: currentSubstationLabel,
      measurementPointLabel: currentMeasurementPointLabel,
      tsoId: currentTsoId,
      entityId: currentEntityId,
    } = getCurrentLabelsAndIds(node, parentSubstationLabel, parentMeasurementPointLabel);

    if (node.entityId === deviceId && node.type === 2) {
      return {
        deviceLabel: node.label ?? undefined,
        measurementPointLabel: currentMeasurementPointLabel,
        substationLabel: currentSubstationLabel,
        deviceId,
        tsoId: currentTsoId,
        entityId: currentEntityId,
      };
    }

    if (node.options?.length) {
      const nested = findDeviceAndSubstation(
        node.options,
        deviceId,
        currentSubstationLabel,
        currentMeasurementPointLabel
      );
      if (nested) return nested;
    }
  }

  return null;
}
